import { MenuType } from "../../enums/MenuType";
import { paths } from "../../resources/paths";
import LiveMonitoringPage from "../../../views/Monitoring/LiveMonitoring/LiveMonitoringPage";
import React from "react";

export const MonitoringItems = (t) => [
  {
    key: "1",
    icon: "fas fa-video",
    text: t("liveMonitoring"),
    path: paths.monitoring.liveMonitoring,
    render: <LiveMonitoringPage />,
    MenuType: MenuType.MAINMENU,
  },
];
